import { StylovyzeIconProps } from '@innovyze/stylovyze';
import React from 'react';

const AnalysisIcon: React.FC<StylovyzeIconProps> = ({
    color,
    ...props
}: StylovyzeIconProps) => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.35938 3.5V20.5H18.6406V6.15625L16.25 3.5H5.35938ZM6.42188 19.4375V4.5625H15.7767L15.8006 4.58906V6.67209H17.5781V19.4375H6.42188Z" fill="white"/>
        <path d="M15.6793 12.3704H13.948V15.8267H15.6793V12.3704Z" fill="white"/>
        <path d="M12.8654 10.395H11.134V15.826H12.8654V10.395Z" fill="white"/>
        <path d="M10.0519 8.17334H8.32056V15.826H10.0519V8.17334Z" fill="white"/>
        </svg>
    );
};

export default AnalysisIcon;
